import { lazy } from 'react';

const NotFound = lazy(() => import('../pages/NotFound'));

import FoodsAdminPage from '../pages/admin/foods/page';

const routes = [
  {
    path: '/',
    element: <FoodsAdminPage />,
  },
  
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
